import { Controller } from "@hotwired/stimulus"
import { applyEnter, animateOut } from "./utils/motion"

// Popover — like dropdown but for rich content (not menu items).
// Cleanup curto-circuita quando o painel já está fechado pra evitar trabalho
// desnecessário em listeners globais.
//
// Motion: painel faz fade+slide (animate-overlay-in/out). A saída espera o
// `animationend` antes de esconder; respeita `prefers-reduced-motion`.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.boundOutside = (e) => {
      if (this._isOpen() && !this.element.contains(e.target)) this.close()
    }
    this.boundEsc = (e) => {
      if (this._isOpen() && e.key === "Escape") {
        this.close()
        this.triggerTarget?.focus?.()
      }
    }
    document.addEventListener("click", this.boundOutside)
    document.addEventListener("keydown", this.boundEsc)
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutside)
    document.removeEventListener("keydown", this.boundEsc)
  }

  toggle(e) {
    e.stopPropagation()
    if (this._isOpen()) this.close()
    else this.open()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    applyEnter(this.panelTarget, "animate-overlay-in")
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  async close() {
    if (!this._isOpen()) return
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", "false")
    await animateOut(this.panelTarget, "animate-overlay-out")
    this.panelTarget.classList.add("hidden")
  }

  _isOpen() { return !this.panelTarget.classList.contains("hidden") }
}
